// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".monaco-editor-custom * {\n  font-size: 14px !important;\n}", "",{"version":3,"sources":["webpack://src/views/panels/hospital/ClassicReport/MonacoEditor.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF","sourcesContent":[".monaco-editor-custom * {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
